import { isNil } from 'lodash';

export const isEmptyAccountId = accountId => isNil(accountId) || accountId === '';
